"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cart = void 0;

var _estore = require("./requests/estore");

var _createFetchRejection = _interopRequireDefault(require("./utilities/createFetchRejection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var cart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apiBase) {
    var response, json;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _estore.cart)(apiBase);

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            json = _context.sent;

            if (!response.ok) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              itemsInCart: json.totalUnitCount || 0,
              userName: json.userName
            });

          case 8:
            return _context.abrupt("return", (0, _createFetchRejection["default"])(response, json));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function cart(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.cart = cart;